<template>
    <div class="sso-links-container">
        <div class="form-group">
            <a :href="classLinkUrl" class="api-signon-btn classlink-signon" v-tooltip="'Log in with ClassLink'">
                <!-- <span class="icon"></span> -->
                <img class="icon" :src="`${routes.cdn_url}/images/redesign/icons/classlink-icon.png`"/>
                <p class="text">ClassLink</p>
            </a>
        </div>
        
        <div class="form-group">
            <a :href="cleverUrl" class="api-signon-btn clever-signon" v-tooltip="'Log in with Clever'">
                <!-- <span class="icon"></span> -->
                <img class="icon" :src="`${routes.cdn_url}/images/redesign/icons/clever-icon.png`"/>
                <p class="text">Clever</p>
            </a>
        </div>

        <template v-if="false">
            <div class="form-group">
                <a href="#" class="api-signon-btn classroom-signon" v-tooltip="'Log in with Google Classroom'">
                    <span class="icon"></span>
                    <p class="text">Google Classroom</p>
                </a>
            </div>

            <div class="form-group">
                <a href="#" class="api-signon-btn schoology-signon" v-tooltip="'Log in with Schoology'">
                    <span class="icon"></span>
                    <p class="text">Schoology</p>
                </a>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data: () => ({
            officeUrl: Nextgenmath.routes.api_url + '/v1.0/login/o365',
        }),
        computed: {
            cleverUrl() {
                // needs CSRF token on state 
                // &state=<?=$csrf_token?>
                return `https://clever.com/oauth/authorize?response_type=code&client_id=${this.$page.props.clever_id}&redirect_uri=${this.routes.api_url}/v1.0/login/clever`; 
            },
            classLinkUrl() {
                return `${this.routes.api_url}/v1.0/login/redirect/classLink`;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .sso-links-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;

        .api-signon-btn {
            width: 150px;
            height: 150px;
            color: #fff;
            border-radius: 6px;
            display: inline-block;

            &:hover {
                text-decoration: none;
                color: #fff;
                -moz-box-shadow: inset 0 0 0 999px rgba(0,0,0,.1);
                -webkit-box-shadow: inset 0 0 0 999px rgba(0,0,0,.1);
                box-shadow: inset 0 0 0 999px rgba(0,0,0,.1);
            }

            > .icon {
                display: block;
                margin: 1.75rem auto 0.5rem;
                width: 50px;
                // height: 50px;
                // margin: 10px;
                // margin-right: 35px;
                // display: inline-block;
                // background: url('https://cdn.nextgenmath.com/images/login/api-sprite.png?v=9182376') no-repeat;
            }

            > .text {
                text-align: center;
                // display: block;
                // position: relative;
                // width: 100px;
                // margin: 0 auto;
            }

            &.clever-signon {
                background: #2F66A8;

                // > .icon {
                //     background-position: 0 0;
                // }
            }

            &.classlink-signon {
                background: #2a98bb;

                > .icon {
                    width: 70px;
                //     background-position: 0 -56px;
                }
            }

            &.classroom-signon {
                background: #0B7E43;

                // > .icon {
                //     background-position: 0 -84px;
                // }
            }

            &.ms-signon {
                background: #EA3B01;

                // > .icon {
                //     background-position: 0 -28px;
                // }
            }

            &.schoology-signon {
                background: #0677ba;

                // > .icon {
                //     background-position: 0 -111px;
                // }
            }
        }
    }
</style>
